import React from 'react';
import { useTranslation } from 'react-i18next';
import { BiConversation } from 'react-icons/bi';

import SettingsOption, { OptionType } from '../SettingsOption';

const GuestQuestionSetting = ({
  navigateToPrePurchaseQuestions
}: {
  navigateToPrePurchaseQuestions: () => void;
}) => {
  const { t } = useTranslation(['events']);

  return (
    <SettingsOption
      icon={<BiConversation size={20} />}
      title={t('events:settings.guestQuestion.title')}
      actionLabel={t('events:settings.guestQuestion.actionLabel')}
      // value={values?.guestQuestions?.length || values?.googleForms?.url || ''}
      onClick={navigateToPrePurchaseQuestions}
      tooltipMessage={t('events:settings.guestQuestion.tooltip')}
      type={OptionType.Button}
    />
  );
};

export default GuestQuestionSetting;
